<template>
  <el-row class="neworder_framework">
    <el-table :data="orderList" style="width: 100%" @selection-change="selectOrder">
      <template slot="empty">
        <span class="emptyText">暂无新订单信息</span>
      </template>
      <el-table-column align="center" type="selection" width="18">
      </el-table-column>
      <el-table-column align="left" width="400">
        <!--        以下注释，下一行的代码规范被屏蔽检查，因为scope未被使用-->
        <!-- eslint-disable-next-line -->
        <template slot="header" slot-scope="scope">
          <el-row class="button">
            <el-col :span="6">
              <el-button-group>
                <el-button class="small_button" size="small" type="primary" @click="confirmAllOrder">确认订单
                </el-button>
                <el-button class="small_button" size="small" type="danger" @click="cancelAllOrder">取消订单</el-button>
              </el-button-group>
            </el-col>
            <el-col :span="6">
              <el-checkbox v-model="autoRefreshFlag" @change="autoRefreshNewOrder">新订单自动刷新</el-checkbox>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <transition name="el-fade-in-linear">
                <div v-show="refreshBtn" class="transition-box" @click="handleRefreshBtn">有新订单，点击刷新</div>
              </transition>
            </el-col>
          </el-row>
        </template>
        <template slot-scope="scope">
          <el-card class="order_card" shadow="hover">
            <el-row>
              <div class="clearfix">
                <el-col :span="16">
                  <el-row>
                    <el-col :span="24">
                      <p class="order_title">新订单&nbsp;#{{ scope.row.id.substring(scope.row.id.length - 4) }}</p>
                    </el-col>
                    <el-col :span="24">
                      <p class="order_address">{{ scope.row.addressDetail + '--' + scope.row.addressNote }}</p>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <el-button class="order_status" type="text">
                    <span>进行中</span>
                  </el-button>
                </el-col>
              </div>
            </el-row>
            <el-divider></el-divider>
            <order-card :orderInfo=scope.row></order-card>
            <el-row type="flex" justify="center">
              <el-col :span="5">
                <el-button class="button" type="primary" @click="confirmOrder(scope.row)">确认接单</el-button>
              </el-col>
              <el-col :span="5">
                <el-button class="button" type="danger" @click="cancelOrder(scope.row)">取消接单</el-button>
              </el-col>
              <!--              <el-col :span="5">-->
              <!--                <el-button class="button" @click="print(scope.row)">打印</el-button>-->
              <!--              </el-col>-->
            </el-row>
          </el-card>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination :current-page="pageData.currentPage"
                   :page-sizes="[1, 10, 50, 100]"
                   :page-size="pageData.pageSize"
                   :total="pageData.totalSize"
                   layout="sizes, prev, pager, next, total"
                   @size-change="changeSize"
                   @current-change="changeCurrent">
    </el-pagination>
  </el-row>
</template>

<script>
import OrderCard from "../OrderCard.vue"
import DataUntils from "@/utils/data.js";
import startPrint from "../../../../store/print"
import GLOBAL from "@/utils/global.js";


export default {
  name: "NewOrder",
  components: {
    OrderCard
  },
  data() {
    return {
      orderStatus: {
        status: "已付款"
      },
      orderList: [],
      orderSelection: [],
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示条目个数
        totalSize: 0, // 总条目数
      },
      orderCnt: 0,  // 新处理过的订单
      autoRefreshFlag: GLOBAL.autoRefreshFlag,  // 自动刷新
      refreshBtn: false,
    };
  },
  created() {
    this.getOrderList();
  },
  mounted() {
    // this.timer = setInterval(() => {
    //   this.getOrderList();
    // }, 1000 * 5);
  },
  watch: {
    // orderList: {
    //   handler: function (val) {
    //     this.$emit('newOrderCount', val.length);
    //   }
    // }
    "pageData.totalSize"() {
      this.getOrderList();
      // this.$emit('newOrderCount', this.pageData.totalSize);
      // this.$emit('newDeliveryCnt', this.orderCnt);
    },

  },

  destroyed() {
    clearInterval(this.timer);
  },

  methods: {
    getOrderList() {
      DataUntils
          .getOrderListByStatus({
            status: this.orderStatus.status,
            page: this.pageData.currentPage,
            pageSize: this.pageData.pageSize
          })
          .then((res) => {
            this.orderList = res.orderList;
            // this.pageData = res.pageData;
            this.pageData.totalSize = res.pageData.totalSize;
            if (!this.$store.state.visitorMode && GLOBAL.debugMode) {
              console.log("--拉取新订单--", res);
            }
          })
    },
    async confirmOrder(val) {
      await DataUntils.judgeOrderStatus(val.id, '已付款', false)
          .then((res) => {
            if (res.data.data === '已付款') {
              DataUntils
                  .confirmOrderByID({
                    orderId: val.id
                  })
                  .then(() => {
                    this.getOrderList();
                    this.$notify({
                      title: '订单确认通知',
                      message: `订单#${val.id.substring(val.id.length - 4)}已确认`,
                      duration: 3000
                    });
                    startPrint(val, false);
                  })
            }
            // // this.orderList = DataUntils.deleteItemFromArray(val, this.orderList);
          })
          .catch((err) => {
            if (!this.$store.state.visitorMode && GLOBAL.debugMode) {
              console.log(err);
            }
          })
      this.getOrderList();
      this.orderCnt = 1;
    },
    confirmAllOrder() {
      if (this.orderSelection.length == 0) {
        this.$message({
          message: '未选择订单',
          type: 'error'
        });
      } else {
        this.$confirm(`您一共选择了${this.orderSelection.length}件订单`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: "success",
        })
            .then(() => {
              let cnt = 0;
              // let orderArray = this.orderList;
              for (let i = 0; i < this.orderSelection.length; i++) {
                DataUntils.judgeOrderStatus(this.orderSelection[i].id, '已付款', true)
                    .then((res) => {
                      if (res.data.data !== '已付款') {
                        cnt += 1;
                      }
                      if (i === this.orderSelection.length - 1) {
                        if (!this.$store.state.visitorMode && GLOBAL.debugMode) {
                          console.log(cnt);
                        }
                        if (cnt !== 0) {
                          this.$alert(
                              `${cnt}个订单被取消，无法打印订单，请刷新后再操作`,
                              '提醒', {
                                confirmButtonText: '确定',
                                type: 'warning',
                                callback: () => {
                                  this.$message({
                                    type: 'warning',
                                    message: '操作已取消'
                                  });
                                }
                              });
                        } else {
                          for (let i = 0; i < this.orderSelection.length; i++) {
                            DataUntils
                                .confirmOrderByID({
                                  orderId: this.orderSelection[i].id
                                })
                                .then(() => {
                                  if (i === this.orderSelection.length - 1) {
                                    this.orderSelection.forEach(element => {
                                      startPrint(element);
                                    });
                                    this.getOrderList();
                                  }
                                })
                          }
                          this.$notify({
                            title: '订单确认通知',
                            message: `${this.orderSelection.length}件订单已确认`,
                            duration: 3000
                          });
                        }
                      }
                    })
                // orderArray = DataUntils.deleteItemFromArray(this.orderSelection[i], orderArray);
              }
              // this.orderList = orderArray;
              this.pageData.totalSize -= this.orderSelection.length;
            });
      }
    },
    async cancelOrder(val) {
      await DataUntils
          .cancelOrderByID({
            orderId: val.id
          });
      this.$notify({
        title: '订单取消通知',
        message: `订单#${val.id.substring(val.id.length - 4)}已取消`,
        duration: 3000
      });
      // this.orderList = DataUntils.deleteItemFromArray(val, this.orderList);
      this.getOrderList();
    },
    cancelAllOrder() {
      if (this.orderSelection.length == 0) {
        this.$message({
          message: '未选择订单',
          type: 'error'
        });
      } else {
        this.$confirm(`您一共选择了${this.orderSelection.length}件订单`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: "error",
        })
            .then(() => {
              let orderArray = this.orderList;
              for (let i = 0; i < this.orderSelection.length; i++) {
                DataUntils
                    .cancelOrderByID({
                      orderId: this.orderSelection[i].id
                    })
                // .then(() => {
                //   if(i === this.orderSelection.length - 1){
                //
                //   }
                // })
                orderArray = DataUntils.deleteItemFromArray(this.orderSelection[i], orderArray);
              }
              this.orderList = orderArray;
              this.pageData.totalSize -= this.orderSelection.length;
              this.$notify({
                title: '订单取消通知',
                message: `${this.orderSelection.length}件订单已取消`,
                duration: 3000
              });
            });
        this.getOrderList();
      }
    },
    selectOrder(val) {
      this.orderSelection = val;
    },
    // 每页显示条目个数更改
    changeSize(pageSize) {
      this.pageData.pageSize = pageSize;
      this.pageData.currentPage = 1;
      this.getOrderList();
    },
    // 当前页数更改
    changeCurrent(currentPage) {
      this.pageData.currentPage = currentPage;
      this.getOrderList();
    },
    //提交打印
    print(data) {
      // console.log(data);
      startPrint(data);
    },
    //  自动刷新新订单
    autoRefreshNewOrder() {
      this.$emit('autoRefresh', this.autoRefreshFlag);
      console.log(this.autoRefreshFlag);
    },
    //  刷新按钮
    handleRefreshBtn() {
      this.getOrderList();
      this.refreshBtn = false;
    }
  },
};
</script>

<style>
@import "../../../../style/Order.css";

.transition-box {
  text-align: center;
  height: 2rem;
  line-height: 2rem;
  font-weight: normal;
  background: #fcf9d7;
  color: #e3b43d;
  cursor: pointer;
  margin-top: 8px;
  border-radius: 4px;
}
</style>
